import React, { useState } from "react";

interface PokemonImageProps {
  isPokemonDancing: boolean;
  isHidden: boolean;
  pokemon: any;
}

const PokemonImage = ({ isHidden, pokemon, isPokemonDancing }: PokemonImageProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="w-full flex justify-center items-center my-4">
      <img
        className={`w-full max-w-[300px] h-auto mx-auto ${!imageLoaded ? "hidden" : ""} ${
          isHidden ? "no-brightness" : ""
        }`}
        data-testid="PokemonImage"
        alt="pokemon here"
        src={pokemon?.sprites?.front_default}
        onLoad={() => {
          setImageLoaded(true);
        }}
      />
    </div>
  );
};

export default PokemonImage;
